export const SET_PENDING = 'MESSAGING/SET_PENDING';
export const SET_NOTIFICATIONS_TOKENS = 'MESSAGING/NOTIFICATIONS/SET_TOKENS';
export const SET_NOTIFICATIONS_FAVORITE_TOKENS = 'MESSAGING/NOTIFICATIONS/SET_FAVORITE_TOKENS';
export const SET_NOTIFICATIONS_DATA = 'MESSAGING/NOTIFICATIONS/SET_DATA';
export const SET_NOTIFICATIONS_PENDING = 'MESSAGING/NOTIFICATIONS/SET_PENDING';
export const SET_NOTIFICATIONS_TEMPLATES = 'MESSAGING/NOTIFICATIONS/TEMPLATES';
export const SET_NOTIFICATIONS_PAGE_NUMBER = 'MESSAGING/NOTIFICATIONS/SET_PAGE_NUMBER';
export const SET_NOTIFICATIONS_PAGE_ITEM_COUNT = 'MESSAGING/NOTIFICATIONS/SET_PAGE_ITEM_COUNT';
export const SET_CAMPAIGNS_DATA = 'MESSAGING/CAMPAIGNS/SET_DATA';
export const SET_CAMPAIGNS_PENDING = 'MESSAGING/CAMPAIGNS/SET_PENDING';
export const SET_CAMPAIGNS_PAGE_NUMBER = 'MESSAGING/CAMPAIGNS/SET_PAGE_NUMBER';
export const SET_CAMPAIGNS_PAGE_ITEM_COUNT = 'MESSAGING/CAMPAIGNS/SET_PAGE_ITEM_COUNT';
